export enum HeaderIconName {
  Menu = 'Menu',
  NavWishlist = 'NavWishlist',
  NavSearch = 'NavSearch',
}

export const headerIconAssets: {
  [key in HeaderIconName]: string;
} = {
  [HeaderIconName.Menu]: require('./ic-burger-menu.svg'),
  [HeaderIconName.NavWishlist]: require('./ic-nav-wishlist.svg'),
  [HeaderIconName.NavSearch]: require('./ic-search.svg'),
};
